import React, { useState, useEffect, useLayoutEffect, useCallback } from "react";
import { getOverviewChannels } from "./channelCache";
import { IOverviewChannel, IChannelTS, IChannelFC, getChannelTS } from "../../../services/api/Dashboard";
import Year, { IYear } from "../../../services/api/Year";
import Month, { IMonth } from "../../../services/api/Month";
import Loading from "../../../components/Loading";
import Select from "../../../components/Form/Select";
import Stack from "./charts/Stack";
import Waterfall from "./charts/Waterfall";
import Bars from "./charts/Bars";

import calendarIcon from "../assets/images/calendar.svg";
import eventIcon from "../assets/images/event.svg";
import Formatter from "../../../services/utils/Formatter";

interface IForecastInfo {
	W1: number;
	W2: number;
	W3: number;
	W4: number;
	Closing: number;
}

interface IGraphData {
	TotalBase: number;
	TotalBaseLY: number;
	TotalBaseYTD: number;
	TotalBaseLYYTD: number;
	TotalW: IForecastInfo;
	TotalWYTD: IForecastInfo;
	TotalMTW: IForecastInfo;
	TotalMTWYTD: IForecastInfo;
}

interface ICountryCloseupTableContent {
	name: string;
	valueBaseLY: number;
	valueBase: number;
	valueLFCT: number;
	tsValue: number;
	valueBaseLYYTD: number;
	valueBaseYTD: number;
	valueLFCTYTD: number;
	tsValueYTD: number;
}


const CountryCloseup: React.FC = () => {
	const [loading, isLoading] = useState<Boolean>(true);
	const [years, setYears] = useState<IYear[]>([]);
	const [months, setMonths] = useState<IMonth[]>([]);
	const [countries, setCountries] = useState<IOverviewChannel[]>([]);
	const [countriesYTD, setCountriesYTD] = useState<IOverviewChannel[]>([]);
	const [groups, setGroups] = useState<IOverviewChannel[]>([]);
	const [groupsYTD, setGroupsYTD] = useState<IOverviewChannel[]>([]);
	const [current, setOverview] = useState<IOverviewChannel>({} as IOverviewChannel);
	const [currentYTD, setOverviewYTD] = useState<IOverviewChannel>({} as IOverviewChannel);
	const [active, setActive] = useState<IOverviewChannel>({} as IOverviewChannel);
	const [activeYTD, setActiveYTD] = useState<IOverviewChannel>({} as IOverviewChannel);
	
	const [loadTable, setLoadTable] = useState<Boolean>(true);
	const [tableContent, setTableContent] = useState<Array<ICountryCloseupTableContent>>([]);
	const [graphContent, setGraphContent] = useState<IGraphData>({} as IGraphData);
	const [monthData, setMonthData] = useState<any[]>([]);
	const [monthDataYTD, setMonthDataYTD] = useState<any[]>([]);

	const [year, setYear] = useState<number>(0);
	const [month, setMonth] = useState<number>(0);
	const [fCenario, setFCenario] = useState<string>("LY");
	const [tstype, setType] = useState<string>("BP");
	const [fWeek, setFWeek] = useState<string>("FW1");
	const graphColors: string[] = ["#f91054", "#fcc003", "#00162b", "#00162b", "#656061", "#f4801f", "#07173b"];

	const [selectedGroup, setSelectedGroup] = useState<string>();
	const [selectedCountry, setSelectedCountry] = useState<string>();

	const date = new Date();
	

	function populateCountry(obj: IOverviewChannel): IOverviewChannel[] {
		let countriesTmp: IOverviewChannel[] = [];

		if (obj.longitude !== 0 && obj.latitude !== 0)
			countriesTmp.push(obj);

		if (obj.children) {

			obj.children.forEach((objC) => {
				countriesTmp = countriesTmp.concat(populateCountry(objC));
			});
		}

		return countriesTmp;
	}

	function populateGroup(obj: IOverviewChannel): IOverviewChannel[] {
		let groupsTmp: IOverviewChannel[] = [];

		if (obj.children) {

			groupsTmp.push(obj);

			obj.children.forEach((objC) => {
				groupsTmp = groupsTmp.concat(populateGroup(objC));
			});
		}

		return groupsTmp;
	}

	async function LoadOverview(year: number, month: number) {
		isLoading(true);

		const {overview, ytdOverview} = await getOverviewChannels(year, month);

		setOverview(overview)
		setOverviewYTD(ytdOverview);

		let countriesTmp: IOverviewChannel[] = populateCountry(overview);
		let countriesTmpYTD: IOverviewChannel[] = populateCountry(ytdOverview);

		setCountries(countriesTmp);
		setCountriesYTD(countriesTmpYTD);

		let groupsTmp: IOverviewChannel[] = populateGroup(overview);
		let groupsTmpYTD: IOverviewChannel[] = populateGroup(ytdOverview);

		setGroups(groupsTmp);
		setGroupsYTD(groupsTmpYTD);

		//show data
		if (selectedGroup != null && selectedGroup != "") {
			let idxGroup = new Number(selectedGroup) as number;
			setActive(groupsTmp[idxGroup]);
			setActiveYTD(groupsTmpYTD[idxGroup]);
			setSelectedGroup(idxGroup + "");
			setSelectedCountry("");

			console.log("Display group: " + idxGroup, groupsTmp[idxGroup].code);
		}
		else if (selectedCountry != null && selectedCountry != "") {
			let idxCountry = new Number(selectedCountry) as number;
			setActive(countriesTmp[idxCountry]);
			setActiveYTD(countriesTmpYTD[idxCountry]);
			setSelectedGroup("");
			setSelectedCountry(idxCountry + "");

			console.log("Display country: " + idxCountry, countriesTmp[idxCountry].code);
		}
		else {
			//show LATAM data
			setActive(groupsTmp[0]);
			setActiveYTD(groupsTmpYTD[0]);
			setSelectedGroup("0");
			setSelectedCountry("");

			console.log("Display group: " + 0, groupsTmp[0].code);
		}

		isLoading(false);
	}

	useLayoutEffect(() => {
		Promise.all([Year.GetAll(), Month.GetAll()])
			.then((value) => {
				const years = value[0].filter((value) => { return value.active });
				setYears(years);
				setMonths(value[1]);

				setYear(years[0].name);
				setMonth(date.getMonth() + 1);

				LoadOverview(years[0].name, date.getMonth() + 1);
			})
			.catch(console.log);
	}, []);

	useEffect(() => {
		if (!loading && year > 0 && month > 0)
			LoadOverview(year, month);
	}, [year, month]);

	function mapList(obj: any): any {
		return { value: obj.id, label: obj.name };
	}

	function filterSales(obj: any): boolean { return obj.isSales }

	let label: any = {
		"FW1": "FW1",
		"FW2": "FW2",
		"FW3": "FW3",
		"FW4": "FW4",
		"MTDW1": "MTDW1",
		"MTDW2": "MTDW2",
		"MTDW3": "MTDW3",
		"MTDW4": "MTDW4",
		"ACT": "CLOSING"
	}

	useEffect(() => {
		if(active.name && activeYTD.name){
			getActiveCountryData(active, activeYTD);
		}
	}, [active, activeYTD, fWeek, tstype])


	function getActiveCountryData(country: IOverviewChannel, countryYTD: IOverviewChannel){
		setLoadTable(true);

		const forecastInfo: IForecastInfo = {
			W1: 0,
			W2: 0,
			W3: 0,
			W4: 0,
			Closing: 0
		};
		
		const countryGraphData: IGraphData = {
			TotalBase: 0,
			TotalBaseLY: 0,
			TotalBaseLYYTD: 0,
			TotalBaseYTD: 0,
			TotalW: {...forecastInfo},
			TotalWYTD: {...forecastInfo},
			TotalMTW: {...forecastInfo},
			TotalMTWYTD: {...forecastInfo},
		}

		const countryData: Array<ICountryCloseupTableContent> = [];

		const month: any = [
			{ category: "LY" },
			{ category: tstype },
			{ category: "LFCT" },
			{ category: label[fWeek] }
		];
		const monthYTD:any = [
			{ category: "LY" },
			{ category: tstype },
			{ category: "LFCT" },
			{ category: label[fWeek] }
		];

		country.forecastChannels.filter(filterSales).map((obj: IChannelFC, i: number) => {
			const channelTS: IChannelTS = country.tradeSalesChannels.filter(filterSales)[i];
			const channelFC: IChannelFC = country.forecastChannels.filter(filterSales)[i];
			const channelFCYTD: IChannelFC = countryYTD.forecastChannels.filter(filterSales)[i];
			const channelTSYTD: IChannelTS = countryYTD.tradeSalesChannels.filter(filterSales)[i];

			const valueBase: number = getChannelTS(channelTS, tstype);
			let valueBaseYTD: number = getChannelTS(channelTSYTD, tstype);

			valueBaseYTD += valueBase;

			const tsValue: number =
				fWeek === "ACT" ? channelTS.tradeSalesActual :
				fWeek === "FW1" ? obj.tradeSalesForecastWeek1 :
				fWeek === "FW2" ? obj.tradeSalesForecastWeek2 :
				fWeek === "FW3" ? obj.tradeSalesForecastWeek3 :
				fWeek === "FW4" ? obj.tradeSalesForecastWeek4 :
									fWeek === "MTDW1" ? obj.tradeSalesMonthTodayWeek1 :
										fWeek === "MTDW2" ? obj.tradeSalesMonthTodayWeek2 :
											fWeek === "MTDW3" ? obj.tradeSalesMonthTodayWeek3 :
												fWeek === "MTDW4" ? obj.tradeSalesMonthTodayWeek4 : 0;

			
			let tsValueYTD: number =
				fWeek === "ACT" ? channelTSYTD.tradeSalesActual :
				fWeek === "FW1" ? channelFCYTD.tradeSalesForecastWeek1 :
				fWeek === "FW2" ? channelFCYTD.tradeSalesForecastWeek2 :
				fWeek === "FW3" ? channelFCYTD.tradeSalesForecastWeek3 :
				fWeek === "FW4" ? channelFCYTD.tradeSalesForecastWeek4 :
									fWeek === "MTDW1" ? channelFCYTD.tradeSalesMonthTodayWeek1 :
										fWeek === "MTDW2" ? channelFCYTD.tradeSalesMonthTodayWeek2 :
											fWeek === "MTDW3" ? channelFCYTD.tradeSalesMonthTodayWeek3 :
												fWeek === "MTDW4" ? channelFCYTD.tradeSalesMonthTodayWeek4 : 0;
			//get current value + YTD
			tsValueYTD += tsValue;

			let valueLFCT: number = 0;
			let valueLFCTYTD: number = 0;
			let valueBaseLY: number = 0;
			let valueBaseLYYTD: number = 0;

			let filteredSales = country.lastYear.forecastChannels && country.lastYear.forecastChannels.filter(filterSales);

			valueBaseLY = filteredSales && filteredSales[i] ? filteredSales[i].tradeSalesFCT : 0;

			valueLFCT = 
				fWeek === "ACT" ? obj.tradeSalesForecastWeek4 :
				fWeek === "FW4" ? obj.tradeSalesForecastWeek3 :
				fWeek === "FW3" ? obj.tradeSalesForecastWeek2 :
				fWeek === "FW2" ? obj.tradeSalesForecastWeek1 :
				fWeek === "FW1" ? obj.tradeSalesForecastWeek1 :
								fWeek === "MTDW4" ? obj.tradeSalesMonthTodayWeek3 :
									fWeek === "MTDW3" ? obj.tradeSalesMonthTodayWeek2 :
										fWeek === "MTDW2" ? obj.tradeSalesMonthTodayWeek1 :
				obj.tradeSalesMonthTodayWeek1;
			
			let filteredSalesYTD = countryYTD.lastYear.forecastChannels && countryYTD.lastYear.forecastChannels.filter(filterSales);

			valueBaseLYYTD = filteredSalesYTD && filteredSalesYTD[i] ? filteredSalesYTD[i].tradeSalesFCT : 0;
			
			valueLFCTYTD =
				fWeek === "ACT" ? (channelFCYTD.tradeSalesForecastWeek4 + channelFC.tradeSalesForecastWeek4) :
				fWeek === "FW4" ? (channelFCYTD.tradeSalesForecastWeek3 + channelFC.tradeSalesForecastWeek3) :
				fWeek === "FW3" ? (channelFCYTD.tradeSalesForecastWeek2 + channelFC.tradeSalesForecastWeek2) :
				fWeek === "FW2" ? (channelFCYTD.tradeSalesForecastWeek1 + channelFC.tradeSalesForecastWeek1) :
				fWeek === "FW1" ? (channelFCYTD.tradeSalesForecastWeek1 + channelFC.tradeSalesForecastWeek1) :
				fWeek === "MTDW4" ? (channelFCYTD.tradeSalesMonthTodayWeek3 + channelFC.tradeSalesMonthTodayWeek3) :
				fWeek === "MTDW3" ? (channelFCYTD.tradeSalesMonthTodayWeek2 + channelFC.tradeSalesMonthTodayWeek2) :
				fWeek === "MTDW2" ? (channelFCYTD.tradeSalesMonthTodayWeek1 + channelFC.tradeSalesMonthTodayWeek1) :
				(channelFCYTD.tradeSalesMonthTodayWeek1 + channelFC.tradeSalesMonthTodayWeek1);

			// Se FCT for 0 ignorar valor do YTD
			tsValueYTD = tsValue === 0 ? 0 : tsValueYTD;
			valueLFCTYTD = tsValue === 0 ? 0 : valueLFCTYTD;
			valueBaseYTD = tsValue === 0 ? 0 : valueBaseYTD;

			countryData.push({
				name: obj.name,
				tsValue,
				tsValueYTD,
				valueBase,
				valueBaseLY,
				valueBaseLYYTD,
				valueBaseYTD,
				valueLFCT,
				valueLFCTYTD
			});

			//#region GRAPH DATA
			countryGraphData.TotalBase += valueBase;
			countryGraphData.TotalBaseLY += valueBaseLY;

			countryGraphData.TotalBaseYTD += valueBaseYTD;
			countryGraphData.TotalBaseLYYTD += valueBaseLYYTD;

			countryGraphData.TotalW.W1 += obj.tradeSalesForecastWeek1;
			countryGraphData.TotalW.W2 += obj.tradeSalesForecastWeek2;
			countryGraphData.TotalW.W3 += obj.tradeSalesForecastWeek3;
			countryGraphData.TotalW.W4 += obj.tradeSalesForecastWeek4;
			countryGraphData.TotalW.Closing += channelTS.tradeSalesActual;

			countryGraphData.TotalMTW.W1 += obj.tradeSalesMonthTodayWeek1;
			countryGraphData.TotalMTW.W2 += obj.tradeSalesMonthTodayWeek2;
			countryGraphData.TotalMTW.W3 += obj.tradeSalesMonthTodayWeek3;
			countryGraphData.TotalMTW.W4 += obj.tradeSalesMonthTodayWeek4;
			

			countryGraphData.TotalWYTD.W1 += channelFC.tradeSalesForecastWeek1 + (channelFC.tradeSalesForecastWeek1 === 0 ? 0 : channelTSYTD.tradeSalesActual);
			countryGraphData.TotalWYTD.W2 += channelFC.tradeSalesForecastWeek2 + (channelFC.tradeSalesForecastWeek2 === 0 ? 0 : channelTSYTD.tradeSalesActual);
			countryGraphData.TotalWYTD.W3 += channelFC.tradeSalesForecastWeek3 + (channelFC.tradeSalesForecastWeek3 === 0 ? 0 : channelTSYTD.tradeSalesActual);
			countryGraphData.TotalWYTD.W4 += channelFC.tradeSalesForecastWeek4 + (channelFC.tradeSalesForecastWeek4 === 0 ? 0 : channelTSYTD.tradeSalesActual);
			countryGraphData.TotalWYTD.Closing += channelTS.tradeSalesActual + (channelTS.tradeSalesActual === 0 ? 0 : channelTSYTD.tradeSalesActual);

			countryGraphData.TotalMTWYTD.W1 += channelFC.tradeSalesMonthTodayWeek1 + (channelFC.tradeSalesMonthTodayWeek1 === 0 ? 0 : channelTSYTD.tradeSalesActual);
			countryGraphData.TotalMTWYTD.W2 += channelFC.tradeSalesMonthTodayWeek2 + (channelFC.tradeSalesMonthTodayWeek2 === 0 ? 0 : channelTSYTD.tradeSalesActual);
			countryGraphData.TotalMTWYTD.W3 += channelFC.tradeSalesMonthTodayWeek3 + (channelFC.tradeSalesMonthTodayWeek3 === 0 ? 0 : channelTSYTD.tradeSalesActual);
			countryGraphData.TotalMTWYTD.W4 += channelFC.tradeSalesMonthTodayWeek4 + (channelFC.tradeSalesMonthTodayWeek4 === 0 ? 0 : channelTSYTD.tradeSalesActual);
			//#endregion

			//LY			
			month[0][obj.name] = valueBaseLY;
			monthYTD[0][obj.name] = valueBaseLYYTD;
			
			//CRE
			month[1][obj.name] = valueBase;
			monthYTD[1][obj.name] = valueBaseYTD;

			//LFCT
			month[2][obj.name] = valueLFCT;
			monthYTD[2][obj.name] = valueLFCTYTD;

			//FCT
			month[3][obj.name] = tsValue;
			monthYTD[3][obj.name] = tsValueYTD;			
		})

		setTableContent(countryData);
		setGraphContent(countryGraphData);
		setMonthData(month);
		setMonthDataYTD(monthYTD);

		setLoadTable(false);

	};

	function renderForecastGraphs(data: IGraphData){	
		return(
			<>
				<div className="col--2">
					<div className="targetChart">
						<div className="percent red">
							<span>{Formatter.DisplayPercent((data.TotalW.W1 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W2 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W3 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W4 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.Closing / data.TotalBase - 1) * 100)}</span>
						</div>
						<div className="percent blue">
							<span>{Formatter.DisplayPercent((data.TotalW.W1 / data.TotalBaseLY - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W2 / data.TotalBaseLY - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W3 / data.TotalBaseLY - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W4 / data.TotalBaseLY - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.Closing / data.TotalBaseLY - 1) * 100)}</span>
						</div>
						<Bars
							id="target1div"
							data={[
								{ category: " ", value: 0 },
								{ category: "W1", value: data.TotalW.W1 },
								{ category: "W2", value: data.TotalW.W2 },
								{ category: "W3", value: data.TotalW.W3 },
								{ category: "W4", value: data.TotalW.W4 },
								{ category: "CLOSING", value: data.TotalW.Closing },
								{ category: "  ", value: 0 }
							]}
							targets={[
								{
									value: data.TotalBase,
									color: "#ff1054",
									position: data.TotalBase < data.TotalBaseLY ? "top" : "bottom"
								},
								{
									value: data.TotalBaseLY,
									color: "#00162b",
									position: data.TotalBase > data.TotalBaseLY ? "top" : "bottom"
								}
							]}
						/>
						<div className="targetChart__legend">
							<span className="dot targetChart__dot--red"></span>
							<span className="targetChart__label">{tstype}</span>
							<span className="dot targetChart__dot--blue"></span>
							<span className="targetChart__label">LY</span>
						</div>
					</div>
				</div>
				<div className="col--2">
					<div className="targetChart">
						<div className="percent red">
							<span>{Formatter.DisplayPercent((data.TotalW.W1 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W2 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W3 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.W4 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.Closing / data.TotalBase - 1) * 100)}</span>
						</div>
						<div className="percent blue">
							<span>{Formatter.DisplayPercent((data.TotalWYTD.W1 / data.TotalBaseYTD - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalWYTD.W2 / data.TotalBaseYTD - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalWYTD.W3 / data.TotalBaseYTD - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalWYTD.W4 / data.TotalBaseYTD - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalWYTD.Closing / data.TotalBaseYTD - 1) * 100)}</span>
						</div>
						<Bars
							id="target2div"
							data={[
								{ category: " ", value: 0 },
								{ category: "W1", value: data.TotalWYTD.W1 },
								{ category: "W2", value: data.TotalWYTD.W2 },
								{ category: "W3", value: data.TotalWYTD.W3 },
								{ category: "W4", value: data.TotalWYTD.W4 },
								{ category: "CLOSING", value: data.TotalWYTD.Closing },
								{ category: "  ", value: 0 }
							]}
							targets={[
								{
									value: data.TotalBaseYTD,
									color: "#ff1054",
									position: data.TotalBaseYTD < data.TotalBaseLYYTD ? "top" : "bottom"
								},
								{
									value: data.TotalBaseLYYTD,
									color: "#00162b",
									position: data.TotalBaseYTD > data.TotalBaseLYYTD ? "top" : "bottom"
								}
							]}
						/>
						<div className="targetChart__legend">
							<span className="dot targetChart__dot--red"></span>
							<span className="targetChart__label">{tstype}</span>
							<span className="dot targetChart__dot--blue"></span>
							<span className="targetChart__label">LY</span>
						</div>
					</div>
				</div>
			</>
		);

	}

	function renderMonthTodayGraphs(data: IGraphData){
		return(
			<>
				<div className="col--2">
					<div className="targetChart">
						<div className="percent red">
							<span>{Formatter.DisplayPercent((data.TotalMTW.W1 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W2 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W3 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W4 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.Closing / data.TotalBase - 1) * 100)}</span>
						</div>
						<div className="percent blue">
							<span>{Formatter.DisplayPercent((data.TotalMTW.W1 / data.TotalBaseLY - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W2 / data.TotalBaseLY - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W3 / data.TotalBaseLY - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W4 / data.TotalBaseLY - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.Closing / data.TotalBaseLY - 1) * 100)}</span>
						</div>
						<Bars
							id="target3div"
							data={[
								{ category: " ", value: 0 },
								{ category: "W1", value: data.TotalMTW.W1 },
								{ category: "W2", value: data.TotalMTW.W2 },
								{ category: "W3", value: data.TotalMTW.W3 },
								{ category: "W4", value: data.TotalMTW.W4 },
								{ category: "CLOSING", value: data.TotalW.Closing },
								{ category: "  ", value: 0 }
							]}
							targets={[
								{
									value: data.TotalBase,
									color: "#ff1054",
									position: data.TotalBase < data.TotalBaseLY ? "top" : "bottom"
								},
								{
									value: data.TotalBaseLY,
									color: "#00162b",
									position: data.TotalBase > data.TotalBaseLY ? "top" : "bottom"
								}
							]}
						/>
						<div className="targetChart__legend">
							<span className="dot targetChart__dot--red"></span>
							<span className="targetChart__label">{tstype}</span>
							<span className="dot targetChart__dot--blue"></span>
							<span className="targetChart__label">LY</span>
						</div>
					</div>
				</div>
				<div className="col--2">
					<div className="targetChart">
						<div className="percent red">
							<span>{Formatter.DisplayPercent((data.TotalMTW.W1 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W2 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W3 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTW.W4 / data.TotalBase - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalW.Closing / data.TotalBase - 1) * 100)}</span>
						</div>
						<div className="percent blue">
							<span>{Formatter.DisplayPercent((data.TotalMTWYTD.W1 / data.TotalBaseYTD - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTWYTD.W2 / data.TotalBaseYTD - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTWYTD.W3 / data.TotalBaseYTD - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalMTWYTD.W4 / data.TotalBaseYTD - 1) * 100)}</span>
							<span>{Formatter.DisplayPercent((data.TotalWYTD.Closing / data.TotalBaseYTD - 1) * 100)}</span>
						</div>
						<Bars
							id="target4div"
							data={[
								{ category: " ", value: 0 },
								{ category: "W1", value: data.TotalMTWYTD.W1 },
								{ category: "W2", value: data.TotalMTWYTD.W2 },
								{ category: "W3", value: data.TotalMTWYTD.W3 },
								{ category: "W4", value: data.TotalMTWYTD.W4 },
								{ category: "CLOSING", value: data.TotalWYTD.Closing },
								{ category: "  ", value: 0 }
							]}
							targets={[
								{
									value: data.TotalBaseYTD,
									color: "#ff1054",
									position: data.TotalBaseYTD < data.TotalBaseLYYTD ? "top" : "bottom"
								},
								{
									value: data.TotalBaseLYYTD,
									color: "#00162b",
									position: data.TotalBaseYTD > data.TotalBaseLYYTD ? "top" : "bottom"
								}
							]}
						/>
						<div className="targetChart__legend">
							<span className="dot targetChart__dot--red"></span>
							<span className="targetChart__label">{tstype}</span>
							<span className="dot targetChart__dot--blue"></span>
							<span className="targetChart__label">LY</span>
						</div>
					</div>
				</div>
			</>
		);
	}
	
	function getGraphData(isYTD:boolean = false): any {	
		const graphData: any = [];
		const index: number =
			fCenario === "LY" ? 0 :
			fCenario === "LFCT" ? 2 :
			1;

		let totalFC = 0;
		let total = 0;
		const dataFC = isYTD ? monthDataYTD[3] : monthData[3];
		const data = isYTD ? monthDataYTD[index] : monthData[index];
		
		for (const prop in dataFC) {
			if (prop !== "category") {
				total += data[prop];
				totalFC += dataFC[prop];

				graphData.push({
					category: prop,
					value: dataFC[prop] - data[prop]
				});
			}
		};

		graphData.push({
			category: "Forecast",
			value: totalFC
		});

		graphData.splice(0, 0, {
			category: "Total",
			value: total
		});
		return graphData;
	}

	function getFilterTitle(): string {
		return active.code;
	}

	function mapTable(country:ICountryCloseupTableContent){
		return (
			<tr key={"channels" + country.name}>
				<td>{country.name}</td>
				<td>{Formatter.DisplayValue(country.valueBaseLY)}</td>
				<td>{Formatter.DisplayValue(country.valueBase)}</td>
				<td>{Formatter.DisplayValue(country.valueLFCT)}</td>
				<td>{Formatter.DisplayValue(country.tsValue)}</td>
				<td>{Formatter.DisplayPercent((country.tsValue / country.valueBaseLY - 1) * 100)}</td>
				<td>{Formatter.DisplayPercent((country.tsValue / country.valueBase - 1) * 100)}</td>
				<td className="table__data--border">{Formatter.DisplayPercent((country.tsValue / country.valueLFCT - 1) * 100)}</td>

				<td>{country.tsValue === 0 ? 0 : Formatter.DisplayValue(country.valueBaseLYYTD)}</td>
				<td>{country.tsValue === 0 ? 0 : Formatter.DisplayValue(country.valueBaseYTD)}</td>
				<td>{country.tsValue === 0 ? 0 : Formatter.DisplayValue(country.valueLFCTYTD)}</td>
				<td>{country.tsValue === 0 ? 0 : Formatter.DisplayValue(country.tsValueYTD)}</td>
				<td>{country.tsValue === 0 ? 0 : Formatter.DisplayPercent((country.tsValueYTD / country.valueBaseLYYTD - 1) * 100)}</td>
				<td>{country.tsValue === 0 ? 0 : Formatter.DisplayPercent((country.tsValueYTD / country.valueBaseYTD - 1) * 100)}</td>
				<td className="table__data--border">{country.tsValue == 0 ? 0 :Formatter.DisplayPercent((country.tsValueYTD / country.valueLFCTYTD - 1) * 100)}</td>
			</tr>
		);
	}

	function mapTableTotals(tableContent:ICountryCloseupTableContent[]){
		
		var totals:ICountryCloseupTableContent = {
			name: "TOTAL",
			valueBaseLY: 0,
			valueBase: 0,
			valueLFCT: 0,
			tsValue: 0,
			valueBaseLYYTD: 0,
			valueBaseYTD: 0,
			valueLFCTYTD: 0,
			tsValueYTD: 0,
		};

		tableContent.map(country => {
			totals.valueBaseLY += country.valueBaseLY;
			totals.valueBase += country.valueBase;
			totals.valueLFCT += country.valueLFCT;
			totals.tsValue += country.tsValue;
			totals.valueBaseLYYTD += country.tsValue === 0 ? 0 : country.valueBaseLYYTD;
			totals.valueBaseYTD += country.tsValue === 0 ? 0 : country.valueBaseYTD;
			totals.valueLFCTYTD += country.tsValue === 0 ? 0 : country.valueLFCTYTD;
			totals.tsValueYTD += country.tsValue === 0 ? 0 : country.tsValueYTD;
		});

		return mapTable(totals);
	}

	return (
		<React.Fragment>
			{loading ? (
				<Loading />
			) : (
					<React.Fragment>
						<section className="content__block">

							<div className="content__header">
								<h2 className="content__title">Sales - {getFilterTitle()}</h2>
								<div className="multi-selects">
									<div className="content__select">
										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name="fGroup"
											title="Group"
											options={groups.map((obj: IOverviewChannel, i: number) => {
												return { value: i, label: obj.name };
											})}
											value={selectedGroup}
											handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
												let i = +event.currentTarget.value;
												if (i >= 0) {
													setActive(groups[i]);
													setActiveYTD(groupsYTD[i]);
												}
												setSelectedGroup(i + "");
												setSelectedCountry("");
											}}
										/>
									</div>
									<div className="content__select">
										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name="fCountry"
											title="Country"
											options={countries.map((obj: IOverviewChannel, i: number) => {
													return { value: i, label: obj.name };
												})}
											value={selectedCountry}
											handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
												let i = +event.currentTarget.value;
												if (i >= 0) {
													setActive(countries[i]);
													setActiveYTD(countriesYTD[i]);
												}

												setSelectedCountry(i + "");
												setSelectedGroup("");
											}}
										/>
									</div>
								</div>
							</div>
							<div className="content__header">
								<h2 className="content__title"></h2>
								<div className="multi-selects">
									<div className="content__select">
										<Select
											name="fWeek"
											title="Forecast"
											className="select-custom select-custom--medium select-custom--shadow"
											options={[
												{ value: "FW1", label: "FW1" },
												{ value: "FW2", label: "FW2" },
												{ value: "FW3", label: "FW3" },
												{ value: "FW4", label: "FW4" },
												{ value: "MTDW1", label: "MTDW1" },
												{ value: "MTDW2", label: "MTDW2" },
												{ value: "MTDW3", label: "MTDW3" },
												{ value: "MTDW4", label: "MTDW4" },
												{ value: "ACT", label: "CLOSING" }
											]}
											value={fWeek}
											handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
												var value = event.currentTarget.value;
												if (value)
													setFWeek(value);
											}}
										/>
									</div>
									<div className="content__select">
										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name="month"
											title="Month"
											options={months.map(mapList)}
											value={month}
											handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
												var value = +event.currentTarget.value;
												if (value)
													setMonth(value);
											}}
										/>
									</div>
									<div className="content__select">
										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name="year"
											title="Year"
											options={years.map((obj) => { return { value: obj.name, label: obj.name } })}
											value={year}
											handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
												var value = +event.currentTarget.value;
												if (value)
													setYear(value);
											}}
										/>
									</div>
								</div>
							</div>
							<div className="content__select">
								<Select
									name="tstype1"
									title="Reference"
									className="select-custom select-custom--small"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }
									]}
									value={tstype}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										var value = event.currentTarget.value;
										setFCenario(value);
										setType(value);
									}}
								/>
							</div>
							<div className="table">
								<table className="table__data table--row-align-text-right">
									<tbody>
										<tr className="table__data--borderless">
											<td colSpan={7}>
												<img src={calendarIcon} alt="Calendar" className="table__title-img" />
												<span className="table__title">Month</span>
											</td>
											<td colSpan={7}>
												<img src={eventIcon} alt="Event" className="table__title-img" />
												<span className="table__title">YTD</span>
											</td>
										</tr>
										<tr className="table__data--borderless">
											<td></td>
											<td colSpan={7}>
												<span className="table_subtitle">FORECAST {year}</span>
											</td>
											<td colSpan={7}>
												<span className="table_subtitle">FORECAST {year}</span>
											</td>
										</tr>
										<tr>
											<th></th>
											<th>LY</th>
											<th>{tstype}</th>
											<th>LFCT</th>
											<th>{label[fWeek]}</th>
											<th>VS. LY</th>
											<th>VS. {tstype}</th>
											<th>VS. LFCT</th>
											<th>LY</th>
											<th>{tstype}</th>
											<th>LFCT</th>
											<th>{label[fWeek]}</th>
											<th>VS. LY</th>
											<th>VS. {tstype}</th>
											<th>VS. LFCT</th>
										</tr>

										{!loadTable && tableContent.length > 0 && tableContent.map(mapTable)}
										{!loadTable && tableContent.length > 0 && mapTableTotals(tableContent)}
									</tbody>
								</table>
							</div>
						</section>
						
						<section className="content__block">
							<div className="row stack-chart">
								<div className="col--2">
									<h3 className="stack-chart__title">Month Graph</h3>
									<Stack id="monthGraph" data={monthData} />
								</div>
								<div className="col--2">
									<h3 className="stack-chart__title">YTD Graph</h3>
									<Stack id="ytdGraph" data={monthDataYTD} />
								</div>
								<div className="stack-chart__legend">
									{active.tradeSalesChannels.filter(filterSales).map((obj: IChannelTS, i: number) => {
										return (
											<div
												key={"barLegend" + obj.name}
												className="stack-chart__item"
											>
												<span
													className="dot"
													style={{ backgroundColor: graphColors[i] }}
												></span>
												<span className="stack-chart__label">{obj.name}</span>
											</div>
										);
									})}
								</div>
							</div>
						</section>

						<section className="content__block">
							<div className="content__select">
								<Select
									name="fCenario"
									title="Scenario"
									className="select-custom select-custom--small"
									options={[
										{ value: "LY", label: "LY" },
										//{ value: tstype, label: tstype },

										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" },

										{ value: "LFCT", label: "LFCT" }
									]}
									value={fCenario}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {

										var value = event.currentTarget.value
										if (["BP", "FRE", "SRE", "LE", "OP"].includes(value)) {
											setType(value);
										}

										setFCenario(value);
									}}
								/>
							</div>
							<div className="row">
								<div className="col--2">
									<Waterfall id="chartS1div" data={getGraphData()} />
								</div>
								<div className="col--2">
									<Waterfall id="chartS2div" data={getGraphData(true)} />
								</div>
							</div>
						</section>

						<section className="content__block">
							<div className="row">
								<div className="col--4">
									<h2 className="content__title">Forecast</h2>
								</div>
							</div>
							<div className="row">
								{!loadTable && renderForecastGraphs(graphContent)}
							</div>
							<div className="row">
								<div className="col--4">
									<h2 className="content__title">Month to Date</h2>
								</div>
							</div>
							<div className="row">
								{!loadTable && renderMonthTodayGraphs(graphContent)}
							</div>
						
						</section>
					</React.Fragment>
				)}
		</React.Fragment>
	);
};

export default CountryCloseup;
